export default "__VITE_ASSET__Bv02dF88__"